import React, { useEffect, useState } from "react";
import { Button, Divider, Flex, Tabs, Typography } from "antd";
import {
    CreditCardOutlined,
    FileTextOutlined,
    CrownOutlined,
    CustomerServiceOutlined,
    SketchOutlined,
} from "@ant-design/icons";
import "antd/dist/reset.css";
import { Title3 } from "components/Common/Typography/Titles";
import SubscriptionPlans from "components/UpgradePlan/SubscriptionPlan";
import SubscriptionBillingHistory from "./SubscriptionBillingHistory";
import SubscriptionPaymentMethods from "./SubscriptionPaymentMethods";
import diamondIcon from "../../images/diamondIcon.svg";
import ActiveDiamondIcon from "../../images/ActiveDiamondIcon.svg";
import fileCheckIcon from "../../images/fileCheckIcon.svg";
import ActiveFileCheckIcon from "../../images/fileCheckIcon.svg";
import creditCardIcon from "../../images/creditCardIcon02.svg";
import ActiveCreditCard from "../../images/creditCardIcon02.svg";
import { useLocation } from "react-router-dom";


const { Title } = Typography;

const SubscriptionHeader: React.FC = () => {
    const { search } = useLocation();
    const templateKey = new URLSearchParams(search).get('templateKey');
    const [activeTab, setActiveTab] = useState("1");

    const tabLabels: Record<string, string> = {
        "1": "Plans",
        "2": "Billing History",
        "3": "Payment method",
    };

    const items = [
        {
            key: "1",
            label: (
                <span style={{ fontFamily: "Inter" }} className="flex items-center gap-2">
                    {activeTab === "1" ? <img src={ActiveDiamondIcon} /> : <img src={diamondIcon} />} Plans
                </span>
            ),
        },
        {
            key: "2",
            label: (
                <Flex justify="space-between">
                    <Divider type="vertical" style={{ height: "1.8em", marginLeft: "-10%", marginRight: "-8%" }} />
                    <span style={{ fontFamily: "Inter" }} className="flex items-center gap-2">
                        <img src={fileCheckIcon} /> Billing History
                    </span>
                    <Divider type="vertical" style={{ height: "1.8em", marginLeft: "-8%", marginRight: "-15%" }} />
                </Flex>
            ),
        },
        {
            key: "3",
            label: (
                <span style={{ fontFamily: "Inter" }} className="flex items-center gap-2">
                    {activeTab === "3" ? <img src={ActiveCreditCard} /> : <img src={creditCardIcon} />} Payment method
                </span>
            ),
        },
    ];

    useEffect(() => {
        const tabKey = Number(templateKey);
        if (tabKey) {
            setActiveTab(String(tabKey));
        }
    }, [templateKey]);

    return (
        <>
            {/* <Flex justify="space-between" className="pr-4 h-[51px] border-b bg-white" align="center">
                <div className="flex w-80 pl-6">
                    <p className="text-text-heading font-bold text-xl">
                        Pricing/ &nbsp;
                    </p>
                    <Title3 text={tabLabels[activeTab]} color="text-text-secondary" className="font-bold" />
                </div>
                <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>
                    <Tabs activeKey={activeTab} onChange={setActiveTab} items={items} />
                </div>
                <div className="pr-6" style={{ display: "flex", alignItems: "center" }}>
                    <Button type="primary" icon={<CustomerServiceOutlined />} style={{ background: "#9254de", fontFamily: "Inter" }}>
                        Contact Support
                    </Button>
                </div>
            </Flex> */}
            <Flex justify="space-between" className="pr-4 h-[51px] border-b bg-white px-6 items-center">
                {/* Left Section */}
                <div className="flex min-w-[320px]">
                    <p className="text-text-heading font-bold text-xl">Pricing /&nbsp;</p>
                    <Title3 text={tabLabels[activeTab]} color="text-text-secondary" className="font-bold" />
                </div>

                {/* Center Tabs */}
                <div className="flex-1 flex justify-center ml-[-30%]">
                    <Tabs activeKey={activeTab} onChange={setActiveTab} items={items} />
                </div>

                {/* Right Section: Support Button */}
                <div className="flex items-center">
                    <Button type="primary" 
                    onClick={() =>
                        window.open("https://share.hsforms.com/15KJkV8HVTjKQHuTWWTnLsgr5699", "_blank")
                      }
                    icon={<CustomerServiceOutlined />} style={{ background: "#9254de", fontFamily: "Inter" }}>
                        Contact Support
                    </Button>
                </div>
            </Flex>
            {activeTab === "1" && (
                <div className="other-page-wrapper">
                    <SubscriptionPlans />
                </div>
            )}
            {activeTab === "2" && (
                <div className="other-page-wrapper">
                    <SubscriptionBillingHistory />
                </div>
            )}
            {activeTab === "3" && (
                <div className="other-page-wrapper">
                    <SubscriptionPaymentMethods />
                </div>
            )}
        </>
        // <div>
        //     <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        //         <div className="pl-6" style={{ display: "flex", alignItems: "center" }}>
        //             <Title3 text="Pricing" color="text-text-secondary" className="font-bold" />
        //             <span style={{ marginLeft: "4px", fontWeight: "bold", color: "#262626" }}>/ {tabLabels[activeTab]}</span>
        //         </div>
        //         <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>
        //             <Tabs activeKey={activeTab} onChange={setActiveTab} items={items} />
        //         </div>
        //         <div className="pr-6" style={{ display: "flex", alignItems: "center" }}>
        //         <Button type="primary" icon={<CustomerServiceOutlined />} style={{ background: "#9254de" }}>
        //             Contact Support
        //         </Button>
        //         </div>
        //     </div>
        //     {activeTab === "1" && (
        //         <div className="other-page-wrapper">
        //             <SubscriptionPlans />
        //         </div>
        //     )}
        //     {activeTab === "2" && (
        //         <div className="other-page-wrapper">
        //             <SubscriptionBillingHistory />
        //         </div>
        //     )}
        //     {activeTab === "3" && (
        //         <div className="other-page-wrapper">
        //             <SubscriptionPaymentMethods />
        //         </div>
        //     )}
        // </div>
    );
};

export default SubscriptionHeader;
